import { InviteUserRequestRole } from '@uturn/api/v2';
import { z } from '@uturn/portal/zod';
import { phoneNumber } from '@uturn/portal/zod/schema';
import { RequiredField } from '@uturn/portal/zod/utils';

/** @see InviteUserRequest */
export const formInviteUserSchema = z.object({
	role: z.nativeEnum(InviteUserRequestRole).describe(RequiredField),
	firstName: z.string().trim().min(1).describe(RequiredField),
	lastName: z.string().trim().min(1).describe(RequiredField),
	email: z.string().email().describe(RequiredField),
	phoneNumber: phoneNumber.schema.describe(RequiredField),
});
